import React from "react"
import { Header } from "./navigation/header"
import { Footer } from "./footer/footer"
import { AnimatePresence, motion } from "framer-motion"

import { useLocation } from "@reach/router"

import "./layout.css"

const Layout = ({ children }) => {
  const { pathname } = useLocation()

  return (
    <>
      <Header />
      <AnimatePresence exitBeforeEnter>
        <motion.main
          className="w-full absolute top-0 left-0"
          key={pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            ease: "easeInOut",
            duration: 0.5,
          }}
        >
          {children}
          <Footer />
        </motion.main>
      </AnimatePresence>
    </>
  )
}

export default Layout
